export { default as HUINavTabGroup } from './hui-nav-tab-group';
export type { HUINavTabGroupProps } from './types';
